(function(){
  function formatMoney(cents){
    return '$' + (cents/100).toLocaleString('en-AU', {minimumFractionDigits:2});
  }

  function init(){
    var chainConfig = document.querySelector('cj-chain-configurator');
    if(!chainConfig) return;

    var toggleBtns = chainConfig.querySelectorAll('.cj-chain-opt');
    var optionsPanel = chainConfig.querySelector('.cj-chain-options');
    var radios = chainConfig.querySelectorAll('.cj-chain-radio');
    var subtotalEl = document.getElementById('cjSubtotalAmount');

    function currentBasePriceCents(){
      var priceText = document.querySelector('.price')?.textContent || '';
      var match = priceText.replace(/[^0-9.]/g, '');
      var val = parseFloat(match);
      return isNaN(val) ? 0 : Math.round(val * 100);
    }

    var chainMode = 'none';
    var selectedChainCents = 0;

    function updateSubtotal(){
      if(!subtotalEl) return;
      var base = currentBasePriceCents();
      subtotalEl.textContent = formatMoney(base + selectedChainCents);
    }

    toggleBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        toggleBtns.forEach(function(b){ b.classList.remove('cj-selected'); });
        btn.classList.add('cj-selected');
        chainMode = btn.dataset.chainMode;
        if(chainMode === 'add'){
          optionsPanel.hidden = false;
        } else {
          optionsPanel.hidden = true;
          selectedChainCents = 0;
          radios.forEach(function(r){ r.checked = false; });
          updateSubtotal();
        }
      });
    });

    radios.forEach(function(radio){
      radio.addEventListener('change', function(){
        selectedChainCents = Math.round(parseFloat(radio.dataset.price) * 100) || 0;
        updateSubtotal();
      });
    });

    var lastBase = currentBasePriceCents();
    setInterval(function(){
      var b = currentBasePriceCents();
      if(b !== lastBase){ lastBase = b; updateSubtotal(); }
    }, 400);

    updateSubtotal();

    var form = document.querySelector('form[action*="/cart/add"]');
    if(!form) return;

    form.addEventListener('submit', function(e){
      var checkedChain = chainConfig.querySelector('.cj-chain-radio:checked');
      if(chainMode !== 'add' || !checkedChain) return;

      if(checkedChain.dataset.pricePending === 'true'){
        e.preventDefault();
        alert('This chain option\'s price has not been confirmed yet and cannot be added to cart. Please choose Pendant Only, a different chain, or contact us.');
        return;
      }

      e.preventDefault();
      var formData = new FormData(form);
      var pendantPayload = {
        items: [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(pendantPayload)
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            items: [{
              id: parseInt(checkedChain.value, 10),
              quantity: 1,
              properties: { 'Added with': document.title }
            }]
          })
        });
      })
      .then(function(){ window.location.href = window.Shopify.routes.root + 'cart'; })
      .catch(function(err){ console.error('Configurator cart error:', err); form.submit(); });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
